import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { ChevronDownIcon, RefreshCwIcon } from 'lucide-react';
import { Button } from '@nxt-shared/ui/components/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@nxt-shared/ui/components/Card';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@nxt-shared/ui/components/Collapsible';
import { globalComponents } from "./i18n.js";
import { reportUsageError } from "./usage/track.js";
// A class component can't call hooks, so the error page is its own component and re-renders on a language switch.
function ErrorPage({ error }) {
    const t = globalComponents.useT();
    return (_jsx("div", { className: "min-h-dvh flex items-start justify-center bg-background px-4 py-10 lg:py-16", children: _jsxs(Card, { className: "w-full max-w-lg", children: [_jsxs(CardHeader, { children: [_jsx(CardTitle, { className: "text-2xl", children: t('errorBoundary.title') }), _jsx(CardDescription, { className: "text-base text-foreground", children: t('errorBoundary.body') })] }), _jsxs(CardContent, { className: "flex flex-col items-start gap-4", children: [_jsx(Button, { variant: "primary", icon: RefreshCwIcon, onClick: () => window.location.reload(), children: t('errorBoundary.reload') }), error && (_jsxs(Collapsible, { className: "w-full", children: [_jsx(CollapsibleTrigger, { render: _jsx(Button, { variant: "link-muted", size: "inline", icon: ChevronDownIcon, className: "[&[data-panel-open]_svg]:rotate-180" }), children: t('errorBoundary.details') }), _jsx(CollapsibleContent, { children: _jsx("pre", { className: "mt-2 overflow-x-auto whitespace-pre-wrap break-words rounded-lg bg-muted p-3 font-mono text-sm", children: error.toString() }) })] }))] })] }) }));
}
export class GlobalErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        reportUsageError(error);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return _jsx(ErrorPage, { error: this.state.error });
        }
        return this.props.children;
    }
}
//# sourceMappingURL=GlobalErrorBoundary.js.map